import { Typography, TypographyProps, styled } from '@mui/material';
import React from 'react';
import { spaceCadet, ultraMarine } from '../../../../../../../../../utils/colors';

interface DensityProps {
  density?: 'panel' | 'page';
}

interface TitleTextProps extends DensityProps {
  dimmed?: boolean;
}

// Typography defaults to variant="body1", which carries its own fixed
// font-size -- that wins over whatever the EventCard wrapper's density class
// sets, so the size has to be set explicitly here rather than left to
// inherit (matches EventCard's own .eventCardTitle values).
export const TitleText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'density' && prop !== 'dimmed',
})<TitleTextProps>(({ density, dimmed }) => ({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  lineHeight: 1.35,
  fontWeight: 600,
  fontSize: density === 'page' ? 17 : 12,
  color: dimmed ? spaceCadet[400] : spaceCadet[500],
}));

export const MetaText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'density',
})<DensityProps>(({ density }) => ({
  fontSize: density === 'page' ? 14 : 12,
  color: spaceCadet[400],
  fontVariantNumeric: 'tabular-nums',
}));

export const CommandsCountText = styled(Typography)({
  fontSize: 14,
  color: spaceCadet[400],
  flexShrink: 0,
});

// Widened type: rendered as a native <button> (component="button") so it's
// its own click target -- a plain styled(Typography) type doesn't expose
// `component`/`type` (same TS2742-adjacent issue as EventCard's own shell).
export const MoreText: React.ComponentType<TypographyProps & { component?: string, type?: 'button' }> = styled(Typography)({
  fontSize: 12,
  fontWeight: 600,
  color: ultraMarine[500],
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  alignSelf: 'flex-start',
  '&:hover': {
    textDecoration: 'underline',
  },
});
